<template>
    <div style="overflow: auto" class="row items-center">
        <div ref="text" class="col" style="margin-right: 15px; white-space: pre-line">
            {{ text }}
        </div>
        <div v-show="params.accept_like === true" class="col-auto" style="padding-right: 10px">
            <ButtonLike :view="view" :page="page"/>
        </div>
    </div>
</template>

<script>
import uiControlMixin from 'src/mixins/ui/uiControlMixin';
import ButtonLike from 'components/ui/extensions/ButtonLike';

export default {
    name: 'Text',
    components: { ButtonLike },
    mixins: [uiControlMixin],
    computed: {
        text () {
            return this.params.text ?? '';
        },
    },
    mounted () {
        const { textAlign } = this.params;
        if (textAlign) {
            switch (textAlign) {
                case 'left':
                    this.$refs.text.classList.add('text-left');
                    break;
                case 'center':
                    this.$refs.text.classList.add('text-center');
                    break;
                case 'right':
                    this.$refs.text.classList.add('text-right');
                    break;
                default:
            }
        }
    },
};
</script>

<style scoped>

</style>
